"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ts_money_1 = require("ts-money");
var ProductVariant = /** @class */ (function () {
    function ProductVariant(json) {
        this.id = json.id;
        this.normalPrice = ts_money_1.Money.fromInteger(json.normalPrice, ts_money_1.Currencies.MYR);
        this.memberPrice = ts_money_1.Money.fromInteger(json.memberPrice, ts_money_1.Currencies.MYR);
        this.primaryAttributeValue = json.primaryAttributeValue;
        this.secondaryAttributeValue = json.secondaryAttributeValue || null;
    }
    Object.defineProperty(ProductVariant.prototype, Symbol.toStringTag, {
        get: function () {
            return 'ProductVariant';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductVariant.prototype, "descriptor", {
        get: function () {
            if (this.secondaryAttributeValue != null) {
                return "".concat(this.primaryAttributeValue, ", ").concat(this.secondaryAttributeValue);
            }
            else {
                return "".concat(this.primaryAttributeValue);
            }
        },
        enumerable: false,
        configurable: true
    });
    return ProductVariant;
}());
exports.default = ProductVariant;
